import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/components';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [
    RouterOutlet, 
    NgxSpinnerModule,
    HeaderComponent
  ],
})
export class MainComponent implements OnInit {
  
  constructor() {}

  ngOnInit() {}
}
